import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  onSnapshot,
} from "firebase/firestore";

export default function CrashUserHistoryTable({ user }) {
  // <-- fixed here!
  const [userHistory, setUserHistory] = useState([]);
  const [loadingHistory, setLoadingHistory] = useState(true);

  useEffect(() => {
    if (!user?.uid) return;
    const q = query(
      collection(db, "crashBets"),
      where("userId", "==", user.uid),
      orderBy("createdAt", "desc"),
      limit(20)
    );
    const unsub = onSnapshot(q, (snap) => {
      const docs = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      setUserHistory(docs);
      setLoadingHistory(false);
    });
    return unsub;
  }, [user]);

  return (
    <div className="mt-8 mb-6 w-full rounded-[28px] bg-[#1f242d] p-4 shadow-[0_24px_70px_rgba(0,0,0,0.28)]">
      <div className="mb-3 text-xl font-bold text-white">
        My Crash History
      </div>
      {loadingHistory ? (
        <div className="text-gray-400 text-center py-8">Loading...</div>
      ) : userHistory.length === 0 ? (
        <div className="text-gray-400 text-center py-8">No history yet.</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full text-white text-sm">
            <thead>
              <tr className="bg-[#202631]">
                <th className="p-2 text-left">Round</th>
                <th className="p-2 text-left">Time</th>
                <th className="p-2 text-left">Bet</th>
                <th className="p-2 text-left">Cashed At</th>
                <th className="p-2 text-left">Payout</th>
                <th className="p-2 text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              {userHistory.map((bet) => (
                <tr
                  key={bet.id}
                  className="border-b border-[#242b35] transition hover:bg-[#1d2430]"
                >
                  <td className="p-2 font-mono">{bet.roundId?.slice(-5)}</td>
                  <td className="p-2">
                    {bet.createdAt?.toDate
                      ? bet.createdAt.toDate().toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                        })
                      : "--:--"}
                  </td>
                  <td className="p-2 font-mono">${bet.amount?.toFixed(2)}</td>
                  <td className="p-2 font-mono">
                    {bet.cashedOutAt ? `${bet.cashedOutAt}x` : "-"}
                  </td>
                  <td className="p-2 font-mono">
                    {bet.status === "cashed" && bet.cashedOutAt
                      ? (bet.amount * bet.cashedOutAt).toFixed(4)
                      : bet.status === "crashed"
                      ? "0"
                      : "-"}
                  </td>
                  <td className="p-2 font-bold">
                    {bet.status === "cashed" && (
                      <span className="text-emerald-300">Cashed</span>
                    )}
                    {bet.status === "crashed" && (
                      <span className="text-rose-300">Crashed</span>
                    )}
                    {bet.status === "active" && (
                      <span className="text-amber-300">Active</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
